<template>
  <div>
    <md-dialog :md-active.sync="createDialog" v-on:md-closed="closed">
      <div class="content-dialog">
        <div class="loading-overlay" v-if="!loadDialog">
          <md-progress-spinner :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <md-card-header>
          <div class="md-title">Создание магазина</div>
        </md-card-header>
        <form class="md-layout">
          <md-card>
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('name')">
                    <label for="name">Название</label>
                    <md-input name="name" v-model="form.name" id="name" autocomplete="disabled" maxlength="200"
                              required></md-input>
                    <div class="md-error" v-if="!this.$v.form.name.required">{{ t('shop.create.required') }}</div>
                  </md-field>
                </div>
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('registry_name')">
                    <label for="registry_name">Юридическое название</label>
                    <md-input name="registry_name" v-model="form.registry_name" id="registry_name"
                              autocomplete="disabled" maxlength="200" required/>
                    <div class="md-error" v-if="!this.$v.form.registry_name.required">{{
                        t('shop.create.required')
                      }}
                    </div>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('tin')">
                    <label for="tnn">БИН</label>
                    <md-input name="tin" id="tin" autocomplete="disabled" v-model="form.tin" required/>
                    <div class="md-error" v-if="!this.$v.form.tin.required">{{ t('shop.create.required') }}</div>
                    <div class="md-error" v-if="!this.$v.form.tin.numeric">{{ t('shop.create.dirty') }}</div>
                  </md-field>
                </div>
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('terminal_number')">
                    <label for="terminal_number">Номер терминала</label>
                    <md-input v-model="form.terminal_number" name="terminal_number" id="terminal_number"
                              autocomplete="disabled" maxlength="20"/>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('address')">
                    <label for="tnn">Адрес</label>
                    <md-input name="address" id="address" autocomplete="disabled" v-model="form.address"/>
                  </md-field>
                </div>

                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('user_name')">
                    <label for="user_name">Логин</label>
                    <md-input name="user_name" id="user_name" autocomplete="disabled" maxlength="200"
                              v-model="form.user_name" required/>
                    <div class="md-error" v-if="!this.$v.form.user_name.required">{{ t('shop.create.required') }}</div>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field>
                    <label for="copy_from_other">Скопировать товары из другой компании</label>
                    <md-select @md-selected="checkCopyFrom" name="copy_from_other" id="copy_from_other"
                               v-model="form.copy_from_other" md-dense required>
                      <md-option value="1" :key="'status_1'">Да</md-option>
                      <md-option value="0" :key="'status_2'">Нет</md-option>
                    </md-select>
                    <div class="md-error" v-if="!this.$v.form.copy_from_other.required">{{
                        t('shop.create.required')
                      }}
                    </div>
                  </md-field>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item" v-if="!this.searchDisable">
                    <CompanySearch v-on:setCompany="setCompany"></CompanySearch>
                  </div>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('is_check_operday')">
                    <label for="is_check_operday">Фискальный</label>
                    <md-select v-model="form.is_check_operday" name="is_check_operday" id="is_check_operday" md-dense
                               required>
                      <md-option value="1" :key="'ekv_1'">Да</md-option>
                      <md-option value="0" :key="'ekv_0'">Нет</md-option>
                    </md-select>
                    <div class="md-error" v-if="!this.$v.form.is_check_operday.required">{{
                        t('shop.create.required')
                      }}
                    </div>
                  </md-field>
                </div>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item ">
                    <md-field :class="getValidationClass('vat_type_id')" v-if="this.country_code === 'kz'">
                      <label for="vat_type_id">Форма НДС</label>
                      <md-select v-model="form.vat_type_id" name="vat_type_id" id="vat_type_id" md-dense required>
                        <md-option value="1" :key="'ekv_1'">Без НДС</md-option>
                        <md-option value="2" :key="'ekv_2'">12 %</md-option>
                      </md-select>
                      <div class="md-error" v-if="!this.$v.form.vat_type_id.required">{{
                          t('shop.create.required')
                        }}
                      </div>
                    </md-field>
                    <md-field :class="getValidationClass('vat_type_id')" v-else>
                      <label for="vat_type_id">Форма НДС</label>
                      <md-select v-model="form.vat_type_id" name="vat_type_id" id="vat_type_id" md-dense required>
                        <md-option value="1" :key="'ekv_1'">УСН Доход</md-option>
                        <md-option value="5" :key="'ekv_2'">Общий 20%</md-option>
                        <md-option value="7" :key="'ekv_3'">УСН Доход - Расход</md-option>
                      </md-select>
                      <div class="md-error" v-if="!this.$v.form.vat_type_id.required">{{
                          t('shop.create.required')
                        }}
                      </div>
                    </md-field>
                  </div>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('is_acquiring_enabled')">
                    <label for="is_acquiring_enabled">Включен эквайринг</label>
                    <md-select v-model="form.is_acquiring_enabled" name="is_acquiring_enabled" id="is_acquiring_enabled"
                               md-dense required>
                      <md-option value="1" :key="'ekv_1'">Да</md-option>
                      <md-option value="0" :key="'ekv_0'">Нет</md-option>
                    </md-select>
                    <div class="md-error" v-if="!this.$v.form.is_acquiring_enabled.required">
                      {{ t('shop.create.required') }}
                    </div>
                  </md-field>
                </div>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item ">
                    <md-field>
                      <label for="tnn">Код магазина в Food</label>
                      <md-input name="food_id" id="food_id" autocomplete="disabled" v-model="form.food_id"/>
                    </md-field>
                  </div>
                </div>
              </div>

              <div class="md-layout md-gutter" v-if="this.country_code === 'kz'">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('is_tap2phone_enabled')">
                    <label for="is_tap2phone_enabled">Включен Tap2Phone</label>
                    <md-select v-model="form.is_tap2phone_enabled" name="is_tap2phone_enabled" id="is_tap2phone_enabled"
                               md-dense required>
                      <md-option value="1" :key="'ekv_1'">Да</md-option>
                      <md-option value="0" :key="'ekv_0'">Нет</md-option>
                    </md-select>
                    <div class="md-error" v-if="!this.$v.form.is_tap2phone_enabled.required">
                      {{ t('shop.create.required') }}
                    </div>
                  </md-field>
                </div>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item ">

                  </div>
                </div>
              </div>

              <!--Только РФ-->
              <div v-if="this.country_code === 'ru'">
                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field :class="getValidationClass('user_inn')">
                      <label for="tnn">ИНН кассира</label>
                      <md-input name="user_inn" id="user_inn" autocomplete="disabled" v-model="form.user_inn"
                                minlength="12" maxlength="12" required/>
                      <div class="md-error" v-if="!this.$v.form.user_inn.required">{{ t('shop.create.required') }}</div>
                      <div class="md-error" v-if="!this.$v.form.user_inn.numeric">{{ t('shop.create.dirty') }}</div>
                      <div class="md-error" v-if="!this.$v.form.user_inn.minLength">{{ t('shop.create.dirty') }}</div>
                      <div class="md-error" v-if="!this.$v.form.user_inn.maxLength">{{ t('shop.create.dirty') }}</div>
                    </md-field>
                  </div>
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item ">
                      <md-field :class="getValidationClass('first_name')">
                        <label for="first_name">Фамилия кассира</label>
                        <md-input name="first_name" id="first_name" autocomplete="disabled" v-model="form.first_name"
                                  maxlength="20" required/>
                        <div class="md-error" v-if="!this.$v.form.first_name.required">{{
                            t('shop.create.required')
                          }}
                        </div>
                      </md-field>
                    </div>
                  </div>
                </div>

                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field :class="getValidationClass('last_name')">
                      <label for="last_name">Имя кассира</label>
                      <md-input name="last_name" id="last_name" autocomplete="disabled" v-model="form.last_name"
                                maxlength="20" required/>
                      <div class="md-error" v-if="!this.$v.form.last_name.required">{{
                          t('shop.create.required')
                        }}
                      </div>
                    </md-field>
                  </div>

                  <div class="md-layout md-gutter">
                    <div class="md-layout-item ">
                      <md-field :class="getValidationClass('middle_name')">
                        <label for="middle_name">Отчество кассира</label>
                        <md-input name="middle_name" id="middle_name" autocomplete="disabled" v-model="form.middle_name"
                                  maxlength="20" required/>
                        <div class="md-error" v-if="!this.$v.form.middle_name.required">{{
                            t('shop.create.required')
                          }}
                        </div>
                      </md-field>
                    </div>
                  </div>
                </div>
              </div>
              <!--Только РФ-->
            </md-card-content>
            <md-card-actions>
              <md-button class="ct-yellow pointer" @click="createDialog = false">Закрыть</md-button>
              <md-button class="md-primary ct-green pointer" @click="submitCreateForm">Создать</md-button>
            </md-card-actions>
          </md-card>
          <md-snackbar :md-active.sync="successCreate">The shop {{ this.form.registry_name }} was create with success!
          </md-snackbar>
        </form>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import HttpClient from '@/api/calls'
import Responses from '@/api/responses'
import {maxLength, minLength, numeric, required, requiredIf} from 'vuelidate/lib/validators'
import CompanySearch from '../common/forms/CompanySearch.vue'

export default {
  components: {CompanySearch},
  name: 'DialogCreateShop',
  mixins: [validationMixin],
  data: () => ({
    form: {
      name: null,
      registry_name: null,
      is_acquiring_enabled: 1,
      is_tap2phone_enabled: 0,
      copy_from_other: 0,
      from_company_id: 0,
      user_name: null,
      address: '',
      food_id: null,
      user_inn: null,
      first_name: null,
      is_check_operday: 1,
      last_name: null,
      middle_name: null,
      terminal_number: null,
      vat_type_id: null,
      tin: null
    },
    successCreate: false,
    sending: false,
    createDialog: false,
    loadDialog: false,
    userData: {},
    name_search: null,
    country_code: 'ru',
    searchDisable: true
  }),
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(4)
      },
      registry_name: {
        required
      },
      tin: {
        required,
        numeric
      },
      user_inn: {
        required: requiredIf(function () {
          return this.isRuRegion
        }),
        numeric,
        minLength: minLength(12),
        maxLength: maxLength(12)
      },
      is_acquiring_enabled: {
        required,
        numeric
      },
      is_tap2phone_enabled: {
        required,
        numeric
      },
      copy_from_other: {
        required,
        numeric
      },
      from_company_id: {
        numeric
      },
      food_id: {
        numeric
      },
      address: {},
      user_name: {
        required
      },
      first_name: {
        required: requiredIf(function () {
          return this.isRuRegion
        })
      },
      vat_type_id: {
        required,
        numeric
      },
      is_check_operday: {
        required,
        numeric
      },
      last_name: {
        required: requiredIf(function () {
          return this.isRuRegion
        })
      },
      middle_name: {
        required: requiredIf(function () {
          return this.isRuRegion
        })
      },
      terminal_number: {}
    }
  },
  computed: {
    isRuRegion () {
      return this.country_code === 'ru'
    }
  },
  methods: {
    setCompany (shopId) {
      this.form.from_company_id = shopId
    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      if (field && this.sending === true) {
        return {
          'md-invalid': field.$invalid || field.$dirty
        }
      }
    },
    checkCopyFrom () {
      this.searchDisable = this.form.copy_from_other !== '1'
    },
    prepareFilters () {
      this.changeFilter()
      let params = {}
      params['page'] = 0
      params['filter'] = this.$store.state.filtersShop
      return params
    },
    submitCheck () {
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        this.submitStatus = 'OK'
      }
    },
    submitCreateForm () {
      this.sending = true
      this.$v.$touch()
      this.submitCheck()

      for (let field in this.form) {
        if (this.form.hasOwnProperty(field)) {
          this.getValidationClass(field)
          this.userData[field] = this.form[field]
        }
      }

      if (this.submitStatus !== 'OK') {
        return
      }
      if (this.country_code === 'ru') {
        this.userData['country_id'] = 3
      } else {
        this.userData['country_id'] = 2
      }

      this.startLoading()
      HttpClient.httpPost(['shop.createShop'], this.userData)
        .then(() => {
          Responses.successRspMessage('Выполнено успешно', 'Создание магазина')
          this.successCreate = true
          this.$store.commit('setFilter', {name: 'name', value: 'deleteFilter'})
          this.$store.commit('setFilter', {name: 'q', value: 'deleteFilter'})
          this.$emit('changeFilter')
          this.stopLoading()
          this.createDialog = false
          this.$emit('closeCreateDialog')
        })
        .catch(err => {
          this.stopLoading()
          console.log(err)
        })
    },
    changeFilter () {
      this.$store.commit('setFilter', {name: 'name', value: this.name_search})
      this.$store.commit('setFilter', {name: 'q', value: this.name_search})
      this.$emit('changeFilter')
    },
    startLoading () {
      this.loadDialog = false
    },
    stopLoading () {
      this.loadDialog = true
    },
    closed () {
      if (this.successCreate === true) {
        this.$emit('closeCreateDialogSuccess')
      } else {
        this.$emit('closeCreateDialog')
      }
      this.successCreate = false
    }
  },
  created () {
    if (this.$store.state.createDialog !== 1) {
      this.createDialog = false
      return false
    }
    this.country_code = this.$store.state.filtersShop.country_code
    this.createDialog = true
    this.stopLoading()
  }
}
</script>

<style lang="scss" scoped>
.md-dialog {
  z-index: 5;
  min-width: 900px;
  max-height: 800px;
  overflow: no-display;
}

.md-card {
  margin: 1px;
  padding: 1px;
  display: inline-block;
  vertical-align: top;
}

.loading-overlay {
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 450px;
  background: none;
  position: absolute;
  z-index: 20 !important;
}

.md-button.ct-green {
  background-color: green !important;
}

.md-button.ct-yellow {
  background-color: #e29641 !important;
}

.md-button.ct-red {
  background-color: #e91e63 !important;
}

.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shops/ShopCreate.vue